import React, { PureComponent } from 'react'
import { compose } from 'helpers'

import reduxForm from 'local_modules/redux-form'

import Button from 'components/ui/Button/Button'
import Select from 'components/ui/form/Select/Select'
import CloseIcon from 'components/ui/CloseIcon/CloseIcon'

import s from './Selectable.scss'


class Selectable extends PureComponent {

  add = ({ selectable }) => {
    const { options, valueLink, fields } = this.props

    if (!selectable) {
      return
    }

    const selectedOption  = options.find(({ value }) => value === Number(selectable))
    const newList         = valueLink.value.concat({
      id: selectedOption.value,
      title: selectedOption.title,
    })

    console.log({
      oldList: valueLink.value,
      newList,
    })
    fields.selectable.set('')
    valueLink.set(newList)
  }

  remove = (removeId) => {
    const { valueLink } = this.props

    const newList = valueLink.value.filter(({ id }) => id !== removeId)

    valueLink.set(newList)
  }

  render() {
    const { placeholder, options, valueLink, fields, submitForm } = this.props

    const selectedValues    = valueLink.value.map(({ id }) => id)
    const selectableOptions = options.filter(({ value }) => !selectedValues.includes(value))

    return (
      <div className={s.list}>
        {
          valueLink.value.map(({ id, title, data }, index) => (
            <div key={index} className={s.option}>
              <div className={s.title}>
                {title}
              </div>
              <CloseIcon
                className={s.close}
                onClick={() => this.remove(id)}
              />
            </div>
          ))
        }
        {
          Boolean(selectableOptions.length) && (
            <div className={s.inputContainer}>
              <Select
                inputWrapperClassName={s.inputWrapper}
                valueLink={fields.selectable}
                placeholder={placeholder}
                options={selectableOptions}
              />
              <Button
                className={s.button}
                title="+"
                green
                onClick={submitForm(this.add)}
              />
            </div>
          )
        }
      </div>
    )
  }
}


export default compose(
  reduxForm(() => ({
    name: 'selectableForm',
    fields: {
      selectable: [],
    },
  })),
)(Selectable)
